export class CashReceiptImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  consecutive: number = 0;
  isChargeAccount: boolean = false;
  dateCashReceipt: Date = new Date;
  clientDocument: string = "";
  clientDocument2: string = "";
  incomeConceptCode: number = 0;
  description: string | null = null;
  observation: string | null = null;
  totalValue: number = 0;
  otherValues: number = 0;
  appliedValue: number = 0;
  refundValue: number = 0;
  utilizationValue: number = 0;
  interestValue: number = 0;
  commissionValue: number = 0;

  wayToPay: number = 0;
  valueWayToPay: number = 0;
  bussinessDocumentsClassId: number = 0;
  bussinessDocumentsTypeCode: number | null = 0;
  invoiceConsecutive: number | null = 0;
  reteFuenteValue: number | null = 0;
  reteIvaValue: number | null = 0;
  reteIcaValue: number | null = 0;
  OtherTaxes: number | null = 0;
  discountValue: number | null = 0;
  paidValue: number | null = 0;

  constructor(counter: number,
    companyId: number,
    branchId: number,
    enterpriseId: number,
    consecutive: number,
    isChargeAccount: boolean,
    dateCashReceipt: Date,
    clientDocument: string,
    clientDocument2: string,
    incomeConceptCode: number,
    description: string | null,
    observation: string | null,
    totalValue: number,
    otherValues: number,
    appliedValue: number,
    refundValue: number,
    utilizationValue: number,
    interesValue: number,
    commissionvalue: number,
    wayToPay: number,
    valueWayToPay: number,
    bussinessDocumentsClassId: number,
    bussinessDocumentsTypeCode: number | null,
    invoiceConsecutive: number | null,
    reteFuenteValue: number | null,
    reteIvaValue: number | null,
    reteIcaValue: number | null,
    OtherTaxes: number | null,
    discountValue: number | null,
    paidValue: number | null,
  ) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.enterpriseId = enterpriseId;
    this.consecutive = consecutive;
    this.isChargeAccount = isChargeAccount;
    this.dateCashReceipt = dateCashReceipt;
    this.clientDocument = clientDocument;
    this.clientDocument2 = clientDocument2;
    this.incomeConceptCode = incomeConceptCode;
    this.description = description;
    this.observation = observation;
    this.totalValue = totalValue;
    this.otherValues = otherValues;
    this.appliedValue = appliedValue;
    this.refundValue = refundValue;
    this.utilizationValue = utilizationValue;
    this.interestValue = interesValue;
    this.commissionValue = commissionvalue;
    this.wayToPay = wayToPay;
    this.valueWayToPay = valueWayToPay;
    this.bussinessDocumentsClassId = bussinessDocumentsClassId;
    this.bussinessDocumentsTypeCode = bussinessDocumentsTypeCode;
    this.invoiceConsecutive = invoiceConsecutive;
    this.reteFuenteValue = reteFuenteValue;
    this.reteIvaValue = reteIvaValue;
    this.reteIcaValue = reteIcaValue;
    this.OtherTaxes = OtherTaxes;
    this.discountValue = discountValue;
    this.paidValue = paidValue;
  }
}